import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import {
  Checkbox,
  Button,
  InlineLoading,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'carbon-components-react';
import { useFormik } from 'formik';
interface FormValues {
  usePermalink: boolean;
}

const SharingEnquiries: React.FC<Props> = ({
  organisation,
  handleInvalidatePermalink,
  invalidatePermalinkError,
  invalidatingPermalink,
  updateOrgConfiguration
}) => {
  const initialValues = {
    usePermalink: organisation?.use_permalink
  };

  const [showModal, setShowModal] = useState<boolean>(false);
  const invalidateClickedInModal = useRef<boolean>(false);
  const { values, setFieldValue } = useFormik<FormValues>({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: () => {}
  });

  const handleCheckboxChange = (checked: boolean) => {
    setFieldValue('usePermalink', checked);
    const data = {
      use_permalink: checked
    };
    updateOrgConfiguration(data);
  };

  useEffect(() => {
    if (invalidateClickedInModal.current) {
      setTimeout(() => {
        invalidateClickedInModal.current = false;
        setShowModal(false);
      }, 1500);
    }
  }, [invalidatingPermalink]);

  const appDom = document.getElementById('app');

  return (
    <div id="sharingEnquiries" className="sharing-enquiries spacing-padding">
      {showModal &&
        appDom &&
        ReactDOM.createPortal(
          <ComposedModal
            size="xs"
            open={true}
            className="sharing-enquiries-confirm-modal"
            onClose={() =>
              invalidatingPermalink ? false : setShowModal(false)
            }
            preventCloseOnClickOutside={true}
          >
            <ModalHeader title="Remove permalinks in use" />
            <ModalBody>
              Your organisation&apos;s existing permalinks will be removed and
              will no longer be accessible. Do you want to continue?
            </ModalBody>
            <ModalFooter>
              <>
                <Button
                  kind="tertiary"
                  onClick={() => setShowModal(false)}
                  disabled={invalidatingPermalink}
                >
                  Cancel
                </Button>
                <Button
                  kind="secondary"
                  onClick={() => {
                    invalidateClickedInModal.current = true;
                    handleInvalidatePermalink();
                  }}
                  disabled={invalidatingPermalink}
                >
                  {!invalidatingPermalink &&
                  !invalidateClickedInModal.current ? (
                    'Yes, continue'
                  ) : (
                    <InlineLoading
                      description={
                        !invalidatingPermalink
                          ? 'Permalink(s) removed'
                          : 'Removing...'
                      }
                      status={!invalidatingPermalink ? 'finished' : 'active'}
                      aria-live={'assertive'}
                    />
                  )}
                </Button>
              </>
            </ModalFooter>
          </ComposedModal>,
          appDom
        )}
      <div className="sub-section-title">Sharing enquiries</div>
      <div className="checkbox-container">
        <Checkbox
          labelText="Enable enquiry permalinks"
          id="sharing-enquiries"
          onChange={(checked: boolean) => handleCheckboxChange(checked)}
          checked={values.usePermalink}
        />
      </div>
      <div className="helper-text">
        Users can copy and share links to plans that can be accessed by anyone
      </div>
      <div className="button-container">
        <Button
          kind="tertiary"
          onClick={() => setShowModal(true)}
          disabled={!organisation?.has_permalink}
        >
          Remove permalinks in use
        </Button>
      </div>
      {invalidatePermalinkError && (
        <div className="helper-text error">{invalidatePermalinkError}</div>
      )}
    </div>
  );
};

interface Props {
  organisation: any;
  updateOrgConfiguration: Function;
  handleInvalidatePermalink: Function;
  invalidatePermalinkError?: string;
  invalidatingPermalink?: boolean;
}

export default React.memo(SharingEnquiries);
